import { BeneficiaryBanksGroupsResponse } from "src/api/interfaces/general";
import {
  FAILED_FETCH_BENEFICIARY_BANKS,
  FETCH_BENEFICIARY_BANKS,
  SUCCESS_FETCH_BENEFICIARY_BANKS
} from "src/services/actions/bank";
import { Action } from "../store";

export type CommonBankState = {
  beneficiaryBanks: BeneficiaryBanksGroupsResponse;
  errorFetchBeneficiaryBanks: [];
  loadingBeneficiaryBanks: boolean;
};

const INITIAL_STATE: CommonBankState = {
  beneficiaryBanks: {} as BeneficiaryBanksGroupsResponse,
  errorFetchBeneficiaryBanks: [],
  loadingBeneficiaryBanks: false
};

const bankReducer = (state = INITIAL_STATE, action: Action): CommonBankState => {
  if (action.type === FETCH_BENEFICIARY_BANKS) {
    return {
      ...state,
      errorFetchBeneficiaryBanks: [],
      loadingBeneficiaryBanks: true
    };
  }

  if (action.type === SUCCESS_FETCH_BENEFICIARY_BANKS) {
    return {
      ...state,
      loadingBeneficiaryBanks: false,
      beneficiaryBanks: action.payload
    };
  }

  if (action.type === FAILED_FETCH_BENEFICIARY_BANKS) {
    return {
      ...state,
      loadingBeneficiaryBanks: false,
      errorFetchBeneficiaryBanks: action.payload
    };
  }

  return state;
};

export default bankReducer;
